import {cloneDeep, merge} from 'lodash'
import FormModal from 'js/components/form-modal'
import openModalConfirm from './_confirm'
import validatePresence from './_validate'
import template from './call-fowarding.pug'

const DefaultData = () => ({
  name: '',
  config: {
    ddiNumberId:''
  }
})

export default Vue.extend({
  template: template(),
  components: {
    FormModal
  },
  props: {
    node: {
      type: Object,
      required: true
    },
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: merge(DefaultData(), this.node),
      DDINumbers: [],
    }
  },
  computed: {
    errors() {
      return merge(DefaultData(), this.data.errors)
    },

    ddiSelectOptions() {
      return this.DDINumbers.map(ddiNumber => ({
        label: ddiNumber.number,
        value: ddiNumber.id
      }))
    }
  },
  watch: {
    campaign: {
      immediate: true,
      handler() {
        this.getDDINumbers()
      }
    }
  },
  methods: {
    getDDINumbers() {
      return API.ddis.index({page: {number: 1, size: 1000}}).then(({data}) => {
        this.DDINumbers = data
      })
    },

    save() {
      validatePresence(this.data, [
        'name',
        'config.ddiNumberId',
      ])

      if (this.data.errors) {
        openModalConfirm().then(() => {
          this.$emit('save', cloneDeep(this.data))
        })
      } else {
        this.$emit('save', cloneDeep(this.data))
      }
    },

    t(key, options = {}) {
      return this.$t(`campaigns.show.automations.workflow.nodes.callFowarding.${key}`, options)
    }
  }
})
